import React from 'react';
import RmsPostFormPage from '../RmsPostFormPage';

export default function EducationHistory() {
  return (
    <RmsPostFormPage
      formKey="educationHistory"
      afterSubmitRoute={(patientRecordId) => `/rms/patient/${encodeURIComponent(patientRecordId)}/overview`}
      backToRoute={(patientRecordId) => `/rms/patient/${encodeURIComponent(patientRecordId)}/overview`}
    />
  );
}


